<template>
  <div>
    <h3 class="d-flex align-items-center justify-content-between">
      Тести
      <b-button
        :to="{ name: 'test-single', params: { id: 'new' } }"
        class="add-user"
        variant="primary"
      >
        <b-icon-plus />
        Створити тест
      </b-button>
    </h3>
    <b-card>
      <b-overlay :show="isLoading" spinner-variant="primary" rounded="lg">
        <div class="tests-list__item" v-for="t in tests" :key="t.id">
          <h5>
            <b-icon-clipboard-check style="margin-right: 10px" />
            <router-link :to="{ name: 'test-single', params: { id: t.id } }">{{
              t.name
            }}</router-link>
          </h5>
          <p class="descriptin" v-if="t.description">
            {{ t.description }}
          </p>
          <div class="meta">
            <div class="item">К-ть питань: {{ t.questions.length }}</div>
          </div>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      tests: [],
    };
  },
  methods: {
    async fetchTests() {
      this.isLoading = true;
      let args = {
        collectionName: "tests",
        limit: 48,
      };
      let result = await this.$db.getCollection(args);
      this.tests = result.docs;

      this.isLoading = false;
    },
  },
  mounted() {
    this.fetchTests();
  },
};
</script>

<style lang="scss" scoped>
h1 {
  .btn {
    margin-left: auto;
    svg {
      margin-right: 8px;
      line-height: 1;
    }
  }
}
.tests-list {
  &__item {
    padding: 10px 0px;
    border-bottom: 1px solid #e7e7e7;
    a {
      color: var(--primary-color);
    }
    .descriptin {
      font-size: 13px;
      margin-top: 16px;
    }
    .meta {
      font-size: 14px;
      .item {
      }
    }
  }
}
</style>
